<template>
  <v-row justify-center>
    <v-dialog v-model="dialogFlag" id="dialogFlag" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">{{ title }}</v-card-title>
        <v-card-text class="center-icon">
          <v-icon text-xs-center x-large color="amber">warning</v-icon>
        </v-card-text>
        <v-card-text>{{ text }}</v-card-text>
        <v-card-actions class="justify-center">
          <v-spacer></v-spacer>
          <v-btn v-if="showCancel === true" text @click="$emit('cancel')">Cancelar</v-btn>
          <v-btn color="red" text @click="$emit('aceptar')">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    dialogFlag: Boolean,
    text: String,
    title: String,
    showCancel: Boolean
  }
}
</script>

<style scoped>
.center-icon {
  text-align: center;
}
.amber--text {
  font-size: 90px !important;
}
</style>